import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import CryptoJS from "crypto-js";
import { APP_CONFIG, IAppConfig } from "src/app/app.config";
import { PlyrComponent } from "ngx-plyr";
import * as moment from "moment";
import Swal from "sweetalert2";
import { StorageService } from "../../services/storage.service";
import { CommonService } from "src/app/services/common.service";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

@Component({
  selector: "app-unapproval-videos",
  templateUrl: "./unapproval-videos.component.html",
  styleUrls: ["./unapproval-videos.component.css"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UnapprovalVideosComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  expandedElement = false;
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  total_count = 0;
  page_count = [];
  page: number = 1;
  pageshow = true;
  total: number;
  p: number;
  pagedItems: any[];
  showLoadMore = false;
  filter: any;
  filter_date: any;
  filter_from: any;
  filter_end: any;
  htmlpageshow: boolean;
  page_size: number = 10;
  professorvideoList: any;
  professorvideo: any;
  videoApproved: any;
  video: any;
  prolength: any;
  roleId = this.storageService.getRole();
  videodec: any;
  showvideo = false;
  viewvideo = false;
  videosrc: any;
  dataindex: any;
  professorid: any;
  video_title: any;
  titleform: FormGroup;
  submitted: boolean;
  IsmodelShow: boolean;
  player: Plyr;
  professorDetails: any;
  subject_id: any;
  department_id: any;
  batch_id: any;
  professor_id: any;
  isLoginType: boolean;
  professor: any;
  batchData: any;
  batch: Object;
  department: Object;
  dept: any;
  subject: Object;
  subjectData: any;
  searchForm: FormGroup;
  assignForm: FormGroup;
  proffid: any;
  filtervalues: boolean;
  chiparray: any[];
  start_date: string;
  end_date: string;
  professorname: any = [];
  professorData: any = [];
  assignSubmitted: boolean = false;
  currentRowId: number;
  videoListId: any;
  assignProfessor: any;
  sessionData: any;
  findedVal: any;
  minDate: Date;
  maxDate: Date;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: Router,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    public commonService: CommonService,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  async ngOnInit(): Promise<void> {
    this.route.queryParams.subscribe((params) => {
      this.isLoginType = !!params["loginType"];
      this.globalService.loginType = params.loginType;
    });
    this.assignForm = this.fb.group({
      sub_name: ["", [Validators.required]],
      profname: ["", [Validators.required]],
    });
    this.maxDate = new Date();
    this.minDate = new Date();
    this.searchForm = this.fb.group({
      id: [""],
      date: [""],
      depname: [""],
      batchname: [""],
      sub_name: [""],
      session: [""],
    });
    this.getDepartment();
    this.getSubject();
    this.getBatch();
    this.getprofessorvideoList();
    this.getProfessor();
    this.getSession();
    await this.getPage(this.page, true);

    this.titleform = this.fb.group({
      title: ["", [Validators.required]],
    });
  }
  async getDepartment() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    this.spinner.hide();
  }
  async getSession() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.forms1["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchForm.controls["session"]?.value
    );
    await this.getprofessorvideoList();
    this.spinner.hide();
  }
  onSessionChangeEvent(isInitLoad?) {
    this.forms1["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.forms1["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        // this.forms1["date"].setValue([new Date(), new Date()]);
        // this.getFilterDate([new Date(), new Date()]);
      }
    } else {
      this.forms1["date"].setValue(null);
      this.getFilterDate(null);
    }
  }
  async getBatch() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = this.batch["content"];
    this.spinner.hide();
  }
  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }
  get forms() {
    return this.titleform.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  get form2() {
    return this.assignForm.controls;
  }
  async videoApprove(id) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      id: id,
      is_video_approval: "1",
      video_title: this.video_title,
    };
    this.videoApproved = await this.globalService.update(
      "classVideoDetail/update-video-approval",
      filter
    );
    this.modalService.dismissAll();
    this.titleform.reset();
    this.video = this.videoApproved["content"];
    this.getprofessorvideoList();
    this.spinner.hide();
  }
  async videoenc(id, index, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let data = this.professorvideo[index];
    this.ls.set("preffessorName", data.professor_details.first_name);
    this.ls.set("subjectName", data.subject_details.name);
    let key = id;
    window.open(
      `/video/edit?key=${key}&isHls=${encrypt(
        enryptText
      )}&loginType=${this.storageService.getImpersonateTextForUrl()}`,
      "_blank"
    );
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }

   async onDepartmentChange() {
    await this.getSubjectDropdown();

  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      sub_name: null,
    });
  }
  

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
      this.onSessionChangeEvent(true);
    }
  }
  openScrollableContent1(shortContent, proid) {
    this.modalService.open(shortContent, { scrollable: true });
    this.professorid = proid;
  }
  videoTitle(form: FormGroup) {
    this.submitted = true;

    if (this.titleform.invalid) {
      return;
    }

    this.video_title = form.value.title;
    this.videoApprove(this.professorid);
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter = filter_date;
      this.filter_from = moment(this.filter[0]).format("YYYY-MM-DD 00:00:00");
      this.filter_end = moment(this.filter[1]).format("YYYY-MM-DD 23:59:59");
      this.start_date = moment(this.filter[0]).format("YYYY-MM-DD");
      this.end_date = moment(this.filter[1]).format("YYYY-MM-DD");
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }

  async getPage(page: number, disableCall: boolean = false) {
    this.page = page;
    if(!disableCall){
    await this.getprofessorvideoList();
    }
    const res = await this.serverCall(this.professorvideo, page);
    this.total = this.total_count;
    this.p = page;

    this.pagedItems = res;
  }

  expandRow(eList) {
    this.professorvideo.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.professorvideo.forEach((list) => {
      list["isExpand"] = false;
    });
  }
  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  Filter(department_id, batch_id, subject_id) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.filter != undefined && this.filter != "") {
      this.chiparray.push(
        "Date :" + " " + this.start_date + " - " + this.end_date
      );
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.subject_id != undefined && this.subject_id != "") {
      var subject = this.subjectData.filter((x) => x.id == this.subject_id);
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.batch_id != undefined && this.batch_id != "") {
      var batch = this.batchData.filter((x) => x.id == this.batch_id);
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }
    if (this.department_id !== "" || this.subject_id !== "" || this.batch_id) {
      this.department_id = department_id;
      this.subject_id = subject_id;
      this.batch_id = batch_id;
    } else {
      this.department_id = "";
      this.subject_id = "";
      this.batch_id = "";
    }

    this.pageshow = true;
    this.page = 1;
    this.getprofessorvideoList();
  }

  async getprofessorvideoList() {
    this.spinner.show();

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      professor_id: this.storageService.getProfessor(),
    };

    this.professorvideoList = await this.globalService.get(
      "classVideoDetail/list-approved-video-details",
      filter,true
    );
    if (this.professorvideoList["status"] === 200) {
      this.professorvideo = this.professorvideoList["content"]["rows"];
      this.professorvideo = this.professorvideo.map((list) => {
        list["isExpand"] = false;
        return list;
      });
      this.professorvideo.forEach((element) => {
        this.professorDetails = element.professor_details;
      });
      this.prolength = this.professorvideo.length;

      if (this.professorvideoList["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      this.showvideo = true;
      this.total_count = this.professorvideoList["content"].count;
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    } else {
      this.spinner.hide();
      this.showLoadMore = true;
    }
    this.spinner.hide();
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getprofessorvideoList();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getprofessorvideoList();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getprofessorvideoList();
  }

  playing(event) {}

  res() {
    this.filtervalues = false;
    this.chiparray = [];
    this.showvideo = false;
    this.viewvideo = false;
    this.department_id = null;
    this.subject_id = null;
    this.batch_id = null;
    this.professor_id = null;
    this.filter_from = null;
    this.filter_end = null;
    this.filter_date = null;
    this.searchForm.reset();
    this.getprofessorvideoList();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getDepartment();
  }

  async onUnapprove(professor) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: [professor.id],
    };
    const updateUnapprove = await this.globalService.update(
      "classVideoDetail/unapprove-videos",
      filter,
      true
    );
    if(updateUnapprove["status"] == 200) {
      Swal.fire("Success!", updateUnapprove["message"], "success");
      this.getprofessorvideoList();
    }
    this.spinner.hide();
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    this.spinner.hide();
  }

  async onSumbit() {
    this.assignSubmitted = true;
    if (this.assignForm.invalid) {
      return;
    }
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.videoListId,
      professor_id: this.assignForm.controls.profname.value,
      subject_id: this.assignForm.controls.sub_name.value,
    };
    this.assignProfessor = await this.globalService.update(
      "classVideoDetail/assign/professor",
      filter
    );
    Swal.fire("", "Successfully assigned");
    this.modalService.dismissAll();
    this.spinner.hide();
  }
}
